<script setup lang="ts">
// Le papier reste blanc dans les deux thèmes : l'aperçu montre ce que l'imprimante sort.
</script>

<template>
  <div
    class="w-full max-w-[420px] shrink-0 overflow-hidden bg-white p-[26px] text-[12px] leading-[1.45] text-[#1a1a1a]"
  >
    <slot />
  </div>
</template>
